// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"pdfmake":"f37e56d606cbc0e17833","canvg":"afb2b69605c4d254e089","xlsx":"d2c7055e166172b46d02"}[chunkId] + ".js";
};